import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const AuthSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
        const processToken = async () => {
      const token = searchParams.get('token');
      const customerParam = searchParams.get('customer');
      
      console.log('AuthSuccess component loaded');
      console.log('Token from URL:', token ? 'Present' : 'Missing');
      console.log('Customer from URL:', customerParam ? 'Present' : 'Missing');
      console.log('Current URL:', window.location.href);
      console.log('User Agent:', navigator.userAgent);
      
      if (token) {
        console.log('Processing token...');
        
        // Decode token to get user info (basic decode, not verification)
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          console.log('Decoded token payload:', payload);
          
          // Store auth data in localStorage
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify({
            id: payload.userId,
            email: payload.email,
            role: payload.role,
            name: payload.name || payload.email
          }));
          
          // Handle customer data
          if (customerParam) {
            // Customer data provided in URL (OAuth login)
            try {
              const customerData = JSON.parse(decodeURIComponent(customerParam));
              console.log('Customer data from URL:', customerData);
              localStorage.setItem('customer', JSON.stringify(customerData));
            } catch (error) {
              console.error('Failed to parse customer data from URL:', error);
              // Fallback to just storing the customer ID
              localStorage.setItem('customer', JSON.stringify({
                id: payload.customer_id
              }));
            }
          } else {
            // No customer data in URL (fallback to API call)
            try {
              const customerResponse = await fetch(`https://plantedhire.com/api/customers`, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              });
              
              if (customerResponse.ok) {
                const customerData = await customerResponse.json();
                localStorage.setItem('customer', JSON.stringify(customerData));
              } else {
                // Fallback to just storing the customer ID
                localStorage.setItem('customer', JSON.stringify({
                  id: payload.customer_id
                }));
              }
            } catch (error) {
              console.error('Failed to fetch customer data:', error);
              // Fallback to just storing the customer ID
              localStorage.setItem('customer', JSON.stringify({
                id: payload.customer_id
              }));
            }
          }
        
        console.log('Auth data stored in localStorage');
        
        // Try a more reliable approach for all browsers
        console.log('Redirecting to dashboard...');
        
        // Use a small delay to ensure localStorage is written
        setTimeout(() => {
          // Force a hard redirect to ensure clean state
          window.location.replace('/app/dashboard');
        }, 100);
      } catch (error) {
        console.error('Error processing auth token:', error);
        navigate('/login?error=invalid_token');
      }
    } else {
      console.log('No token found, redirecting to login');
      navigate('/login?error=no_token');
    }
    };
    
    processToken();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">Completing sign in...</h2>
          <p className="mt-2 text-sm text-gray-600">
            Please wait while we complete your authentication.
          </p>
        </div>
      </div>
    </div>
  );
};